import {
  Component,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { Projectmember } from "./model/projectmember";
import { SessionHelper } from "@src/app/helpers/sessionHelper";
import { Project } from "@src/app/models/project";
import { Stage } from "@src/app/models/stage";
import { Task } from "@src/app/models/task";
import { ProjectportalService } from "./service/projectportal.service";
import { CustomerUser } from "@src/app/models/customeruser";
import { trigger, style, animate, transition } from "@angular/animations";
import { ActivatedRoute } from "@angular/router";
import { Personproject } from "./model/personproject";
import { AuthorizationService } from "@src/app/helpers/authorization.service";
import { Projectcomment } from "@src/app/models/comment";
import { Subscription } from "rxjs";
import { UieventhubService } from "@src/app/helpers/uieventhub/uieventhub.service";
import { DatastoreService } from "@src/app/helpers/datastore/datastore.service";

import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { ModalService } from "@src/app/helpers/modal.service";

@UntilDestroy({ checkProperties: true })
@Component({
  selector: "app-projectportal",
  templateUrl: "./projectportal.component.html",
  styleUrls: ["./projectportal.component.css"],
  animations: [
    trigger("inbgOutAnimation", [
      transition(":enter", [
        style({ opacity: 0, zIndex: 4, position: "absolute" }),
        animate("0.2s ease-out", style({ opacity: 1 })),
      ]),
      transition(":leave", [
        style({ opacity: 0, zIndex: 4, position: "absolute" }),
        animate("0.2s ease-in", style({ opacity: 0 })),
      ]),
    ]),
  ],
})
export class ProjectportalComponent implements OnInit {
  filtertoggle: boolean;
  //@Output() orgstyle:Orgstyle;
  startIndex: number;
  endIndex: number;
  stagesInView: number = 3;
  showCarouselRight: boolean;
  showCarouselLeft: boolean;
  stageWidth: number;
  showalerttoggle: boolean;
  @Output() stageList: Stage[];
  @Output() allStageList: Stage[];
  @Output() taskList: Task[];
  @Output() allTaskList: Task[];
  @Output() modalTask: Task;
  @Input() modalStage: Stage;
  @Output() project: Project;
  @Output() projectMembers: Projectmember[];
  @Output() projectCustomerMembers: Projectmember[];
  @Output() customerUsers: CustomerUser[];
  @ViewChild("stagemodal", { static: true }) stagemodal: ElementRef;
  @ViewChild("rolemodal", { static: true }) rolemodal: ElementRef;
  @ViewChild("closemodal", { static: true }) closemodal: ElementRef;
  projectrole: string;
  @Output() allcommentsList: Projectcomment[];
  @Output() listviewsetting: boolean = false;

  customerportal: boolean;
  formIsValid: boolean;
  dueState: string;
  projectsStateSubscription: Subscription;
  projectCommentSubscription: Subscription;
  addTaskSubscription: Subscription;
  removeTaskSubscription: Subscription;
  taskListFilter: string;
  showSpinner: boolean;
  screenHeight: number;
  screenWidth: number;
  @Output() stage2width: number;
  errorMessage: string;
  @HostListener("window:resize", ["$event"])
  getScreenSize(event?) {
    this.screenHeight = window.innerHeight;
    // if(window.innerWidth > 768 && window.innerWidth < 1024 && SessionHelper.getChatShow() != "false"){
    //   this.screenWidth = window.innerWidth * 0.5;
    // }
    //else
    if (
      window.innerWidth > 1024 &&
      SessionHelper.getChatShow() &&
      SessionHelper.getChatShow() != "false"
    ) {
      this.screenWidth = window.innerWidth - window.innerWidth * 0.33;
    } else {
      this.screenWidth = window.innerWidth;
    }

    if (this.allStageList) {
      this.stagesInView =
        Math.floor(this.screenWidth / 350) <= this.allStageList.length
          ? Math.floor(this.screenWidth / 350)
          : this.allStageList.length;
      this.stageWidth = this.screenWidth / this.stagesInView;
      //console.log("inner width",window.innerWidth);
      //console.log("screen width",this.screenWidth);
      //console.log("stage width",this.stageWidth);
      //console.log("stages in view",this.stagesInView);

      this.endIndex = this.startIndex + this.stagesInView;
      this.stageList = this.allStageList.slice(this.startIndex, this.endIndex);

      if (this.startIndex > 0) {
        this.showCarouselLeft = true;
      } else {
        this.showCarouselLeft = false;
      }
      if (this.allStageList.length > this.endIndex) {
        this.showCarouselRight = true;
      } else {
        this.showCarouselRight = false;
      }
    }
    //console.log("start index", this.startIndex );
    //console.log("end index", this.endIndex );
  }
  constructor(
    private ppsrv: ProjectportalService,
    private route: ActivatedRoute,
    private auth: AuthorizationService,
    private uieventhub: UieventhubService,
    private datastore: DatastoreService,
    private modalservice: ModalService
  ) { }

  canCreateStage() {
    return this.auth.isAuthorized("org_edit", SessionHelper.getChoosenOrg());
  }

  refreshStatusBar(projectId: string) {
    if (projectId != undefined) {
      //   this.ppsrv.generateStats(projectId).pipe(untilDestroyed(this)).subscribe(x =>{
      //   this.ppsrv.getProjectWithStats(projectId).pipe(untilDestroyed(this)).subscribe(p =>{
      //     //console.log('overdue days: ',p);

      //     if(p.overduedays == 0){
      //       this.dueState = "green"
      //     }
      //     if(p.overduedays >= 3){
      //       this.dueState = "red"
      //     }
      //     if(p.overduedays < 3 && p.overduedays > 0){
      //       this.dueState = "yellow"
      //     }
      //     //console.log('project duestate',this.dueState);
      //   });
      // });
      // //TODO add and remove tasks should update the progressbar
      if (this.allTaskList && this.allTaskList.length > 0) {
        //console.log('all task list',this.allTaskList);
        //this.project.progress =  100 * this.allTaskList.filter(task => task.taskstate == 'Done').length/this.allTaskList.length;
      } else {
        let tasks = this.datastore.taskList
          .getValue()
          .filter((t) => t.projectId == projectId);
        //this.ppsrv.getTasks(projectId,new Date().toISOString()).pipe(untilDestroyed(this)).subscribe(tasks => {
        //if view as customer is true, filter out the tasks that are vendor_only
        if (SessionHelper.getViewAsCustomer() == "true") {
          tasks = tasks.filter((t) => t.taskvisibility != "vendor_only");
        }
        this.taskList = tasks;
        this.allTaskList = tasks;

        // if(tasks.length > 0){
        //   this.project.progress =  100 * tasks.filter(task => task.taskstate == 'Done').length/tasks.length;
        // }
        // });
      }
    }
  }
  filterTaskList(type: string) {
    if (type == "myTasks") {
      if (this.taskListFilter == "myTasks") {
        this.taskList = this.allTaskList;
        this.taskListFilter = "";
      } else {
        this.taskList = this.allTaskList.filter(
          (t) => t.responsible == SessionHelper.getUserSub()
        );
        this.taskListFilter = "myTasks";
      }
    }
    if (type == "customerTasks") {
      if (this.taskListFilter == "customerTasks") {
        this.taskList = this.allTaskList;
        this.taskListFilter = "";
      } else {
        this.taskList = this.allTaskList.filter(
          (t) =>
            this.projectCustomerMembers.find(
              (x) => x.userId.substr(0, 36) === t.responsible
            ) != undefined
        );
        this.taskListFilter = "customerTasks";
      }
    }
    if (type == "vendorTasks") {
      if (this.taskListFilter == "vendorTasks") {
        this.taskList = this.allTaskList;
        this.taskListFilter = "";
      } else {
        this.taskList = this.allTaskList.filter(
          (t) =>
            this.projectCustomerMembers.find(
              (x) => x.userId.substr(0, 36) === t.responsible
            ) === undefined
        );
        this.taskListFilter = "vendorTasks";
      }
    }
    if (type == "") {
      this.taskList = this.allTaskList;
      this.taskListFilter = "";
    }
  }
  ngOnDestroy() {
    if (this.projectsStateSubscription) {
      this.projectsStateSubscription.unsubscribe();
    }
    if (this.projectCommentSubscription) {
      this.projectCommentSubscription.unsubscribe();
    }
    if (this.addTaskSubscription) {
      this.addTaskSubscription.unsubscribe();
    }
  }
  ngOnInit() {
    //this.getScreenSize();
    this.uieventhub.currentProjectStateChange$
      .pipe(untilDestroyed(this))
      .subscribe((pid) => {
        this.refreshStatusBar(pid);
      });
    // this.addTaskSubscription = this.uieventhub.addTask$.pipe(untilDestroyed(this)).subscribe(task =>{
    //   this.allTaskList.push(task);
    //   this.refreshStatusBar(task.projectId);
    //  });
    //  this.removeTaskSubscription = this.uieventhub.removeTask$.pipe(untilDestroyed(this)).subscribe(task =>{
    //   this.allTaskList.splice(this.allTaskList.indexOf(task),1)
    //   this.refreshStatusBar(task.projectId);
    //  });
    this.projectCommentSubscription = this.uieventhub.projectComments$
      .pipe(untilDestroyed(this))
      .subscribe((pid) => {
        this.getComments();
        this.getScreenSize();
      });
    this.uieventhub.currentProject$
      .pipe(untilDestroyed(this))
      .subscribe((pid) => {
        this.getScreenSize();
      });
    this.uieventhub.showchatcollapse$
      .pipe(untilDestroyed(this))
      .subscribe((show) => {
        //console.log('showchatcollapse',show);
        // if(show==false){
        //   //Adjust startindex and endindex to fill the stages in view by move the index backwords
        //   if(this.startIndex > 0){
        //     this.startIndex = this.startIndex -1;
        //     this.endIndex = this.endIndex -1;
        //     this.stageList = this.allStageList.slice(this.startIndex,this.endIndex);
        //     if(this.startIndex > 0){
        //       this.showCarouselLeft = true;
        //     }else{
        //       this.showCarouselLeft = false;
        //     }
        //     if(this.allStageList.length > this.endIndex){
        //       this.showCarouselRight = true;
        //     }else{
        //       this.showCarouselRight = false;
        //     }
        //   }
        // }
        this.getScreenSize();
        this.stagesInView;
        let l = this.allStageList.length - this.startIndex;
        if (l < this.stagesInView) {
          //reduce the startindex to show the stages in view
          this.startIndex = this.startIndex - (this.stagesInView - l);
          this.endIndex = this.endIndex - (this.stagesInView - l);
          this.stageList = this.allStageList.slice(
            this.startIndex,
            this.endIndex
          );
          if (this.startIndex > 0) {
            this.showCarouselLeft = true;
          }
          if (this.allStageList.length > this.endIndex) {
            this.showCarouselRight = true;
          }
        }
      });

    this.uieventhub.addLoader("projectportal_tasks");
    this.uieventhub.addLoader("projectportal_stages");
    this.uieventhub.addLoader("projectportal_persons");
    this.uieventhub.addLoader("projectportal_comments");
    this.uieventhub.addLoader("projectportal_projects");
    this.uieventhub.addLoader("projectportal_customermembers");

    this.taskListFilter = "";
    this.dueState = "green";

    let projectid = this.route.snapshot.params.projectid;

    //this.project = JSON.parse(SessionHelper.getPortalProjectList()).find(p => p.projectId.split('_')[0] == projectid);

    //this.project = this.datastore.projectList.getValue().find(p => p.projectId == projectid);
    //this.project.progress = 0;
    // this.project.customer = " ";
    // this.orgstyle = new Orgstyle;
    // this.orgstyle.sidenav = 'top';
    // if(SessionHelper.getDynamicStyle() && SessionHelper.getDynamicStyle() !== 'undefined' ){
    //   this.orgstyle = JSON.parse(SessionHelper.getDynamicStyle());
    // }
    this.projectrole = "Not set";
    this.customerportal = false;
    if (SessionHelper.getCustomer()) {
      this.customerportal = true;
    }
    this.showCarouselRight = false;
    this.showCarouselLeft = false;
    this.startIndex = 0;
    this.endIndex = this.stagesInView;
    this.stageList = [];
    this.taskList = [];
    this.projectMembers = [];
    this.customerUsers = [];
    this.modalStage = new Stage();
    //let projectid = this.route.snapshot.params.projectid;
    SessionHelper.setCurrentProject(projectid);
    //get project from datastore

    this.datastore.projectList$
      .pipe(untilDestroyed(this))
      .subscribe((plist) => {
        this.uieventhub.removeLoader("projectportal_projects");

        if (plist && plist.length > 0) {
          this.project = plist.find((p) => p.projectId == projectid);
          //if component is loaded from a page refresh the project depended data should be loaded
          if (this.uieventhub.getProjectDataLoading() == false) {
            this.datastore.loadProjectDependentData([this.project]);
          }
          SessionHelper.setCurrentProjectFull(JSON.stringify(this.project));
          this.refreshStatusBar(this.project.projectId);
          // this.ppsrv.getProject(SessionHelper.getChoosenOrg(),this.route.snapshot.url[2].path).pipe(untilDestroyed(this)).subscribe(proj => {
          //   this.project = proj;
          //   SessionHelper.setCurrentProjectFull(JSON.stringify(proj));
          //   this.refreshStatusBar(SessionHelper.getCurrentProject());
          //   //console.log(this.project);
          // this.ppsrv.getCustomerMembers(this.project.projectId,this.project.customer).pipe(untilDestroyed(this)).subscribe(cmlist => {
          //   this.projectCustomerMembers = cmlist;
          //   //console.log('Customer members',this.projectCustomerMembers);
          //  //this.uieventhub.removeLoader('projectportal_customermembers');
          // });
          this.projectCustomerMembers = [];
          this.datastore.customersUsers
            .getValue()
            .filter(
              (cu) =>
                cu.customerId.split("_")[0] == this.project.customer.split("_")[0]
            )
            .forEach((cu) => {
              this.projectCustomerMembers.push({
                userId: cu.userId,
                projectId: this.project.projectId,
                personId: cu.userId.split("_")[0],
                fullname: cu.fullname,
                email: cu.email,
                phone: cu.phone,
                im: "",
                iscustomer: true,
              });
            });
          //subscribe to customerUsers
          this.datastore.customersUsers$
            .pipe(untilDestroyed(this))
            .subscribe((cuList) => {
              this.projectCustomerMembers = cuList
                .filter(
                  (cu) =>
                    cu.customerId.split("_")[0] ==
                    this.project.customer.split("_")[0]
                )
                .map((cu) => ({
                  userId: cu.userId,
                  projectId: this.project.projectId,
                  personId: cu.userId.split("_")[0],
                  fullname: cu.fullname,
                  email: cu.email,
                  phone: cu.phone,
                  im: "",
                  iscustomer: true,
                }));
            });
          //console.log(this.projectCustomerMembers);
          this.uieventhub.removeLoader("projectportal_customermembers");

        }
        // this.project  = plist.find(p => p.projectId == projectid);
        //console.log('project',this.project);
      });

    //get tasks from datastore

    this.datastore.taskList$.pipe(untilDestroyed(this)).subscribe((tlist) => {
      if (this.taskList) {
        //console.log('tasklist updated in portal',tlist);
        this.taskList = tlist;
        this.allTaskList = tlist;
        //this.ngOnInit();
      }

      //this.uieventhub.removeLoader('projectportal_tasks');
    });
    if (!this.taskList) {
      this.taskList = this.datastore.taskList.getValue();
      if (this.taskList?.length == 0) {
        //this.uieventhub.removeLoader('projectportal_tasks');
      }
    }

    if (this.project) {

      // });
    } else {
      this.uieventhub.removeLoader("projectportal_customermembers");
    }
    this.ppsrv
      .getStages(SessionHelper.getCurrentProject(), new Date().toISOString())
      .pipe(untilDestroyed(this))
      .subscribe((stages) => {
        //console.log('STAGES',stages);
        //if view as customer is true, filter out the stages that are vendor_only
        if (SessionHelper.getViewAsCustomer() == "true") {
          stages = stages.filter((s) => s.stagevisibility != "vendor_only");
        }
        this.allStageList = stages.sort((a, b) =>
          a.startdate < b.startdate ? -1 : a.startdate > b.startdate ? 1 : 0
        );
        if (this.allStageList.length > this.stagesInView) {
          this.stageList = this.allStageList.slice(
            this.startIndex,
            this.endIndex
          );
          this.showCarouselRight = true;
        } else {
          this.stageList = this.allStageList;
        }
        this.getScreenSize();
        if (this.stageList?.length == 0) {
          this.uieventhub.clearLoaders();
        }
      });

    // get all personproject for the project
    this.datastore.projectpersonList$
      .pipe(untilDestroyed(this))
      .subscribe((ppl) => {
        //this.ppsrv.getMembers(SessionHelper.getCurrentProject()).pipe(untilDestroyed(this)).subscribe(members => {
        let members = ppl.filter(
          (p) => p.projectId == SessionHelper.getCurrentProject()
        );
        //console.log('members',members);
        //filter out the once that are not customers
        this.projectMembers = members.filter((mem) => mem.iscustomer != true);
        //look in the unfiltered list to see if the user is a member
        if (
          members.find(
            (mem) =>
              mem.personId &&
              mem.personId.substr(0, 36) == SessionHelper.getUserSub()
          ) ||
          SessionHelper.getPersonAuth()
        ) {
          //console.log('Already a member')
        } else {
          // show modal
          this.modalservice.close("rolemodal");
          //create member
          //console.log('Create member')
          //console.log('usersub',SessionHelper.getUserSub())
          //console.log('projectmems',this.projectMembers)
        }
        this.uieventhub.removeLoader("projectportal_persons");
      });
    this.getComments();
  }
  getComments() {
    if (SessionHelper.getCurrentProject()) {
      this.ppsrv
        .getComments(SessionHelper.getCurrentProject())
        .pipe(untilDestroyed(this))
        .subscribe((cl) => {
          this.allcommentsList = cl;
          this.uieventhub.removeLoader("projectportal_comments");
        });
    }
  }
  createMember() {
    this.ppsrv
      .getUser(
        this.project.customer,
        SessionHelper.getUserSub(),
        new Date().toISOString()
      )
      .pipe(untilDestroyed(this))
      .subscribe((usr) => {
        let newPersonProject: Personproject = {
          projectId: this.project.projectId,
          personId: usr.userId,
          fullname: usr.fullname,
          im: " ",
          email: usr.email,
          phone: usr.phone,
          title: this.project.title,
          subtitle: this.project.subtitle,
          shortdescription: this.project.shortdescription,
          projectdescription: this.project.projectdescription,
          projectscope: this.project.projectscope
            ? this.project.projectscope
            : "organization",
          projectlocation: this.project.projectlocation,
          start_date: this.project.start_date,
          end_date: this.project.end_date,
          organization: SessionHelper.getChoosenOrg(),
          projectrole: this.projectrole,
          iscustomer: true,
        };
        this.ppsrv
          .createMember(newPersonProject)
          .pipe(untilDestroyed(this))
          .subscribe((resp) => {
            //console.log('Member created');
            this.ngOnInit();
          });
      });
  }
  rightShift() {
    if (this.allStageList.length > this.endIndex) {
      this.startIndex = this.startIndex + 1;
      this.endIndex = this.endIndex + 1;
      this.stageList = this.allStageList.slice(this.startIndex, this.endIndex);
      if (this.startIndex > 0) {
        this.showCarouselLeft = true;
      } else {
        this.showCarouselLeft = false;
      }
      if (this.allStageList.length > this.endIndex) {
        this.showCarouselRight = true;
      } else {
        this.showCarouselRight = false;
      }
    }
    this.getScreenSize();
  }

  leftShift() {
    if (this.startIndex > 0) {
      this.startIndex = this.startIndex - 1;
      this.endIndex = this.endIndex - 1;
      this.stageList = this.allStageList.slice(this.startIndex, this.endIndex);
      if (this.startIndex > 0) {
        this.showCarouselLeft = true;
      } else {
        this.showCarouselLeft = false;
      }
      if (this.allStageList.length > this.endIndex) {
        this.showCarouselRight = true;
      } else {
        this.showCarouselRight = false;
      }
    }
    this.getScreenSize();
  }

  createStage() {
    //if any of the fields are empty, set the error message and return
    if (
      !this.modalStage.enddate ||
      !this.modalStage.startdate ||
      !this.modalStage.title ||
      !this.modalStage.description
    ) {
      this.errorMessage = "modalvalidation.requiredfieldmissing";
    } else {
      this.modalStage.customer = this.project.customer;
      this.modalStage.customername = this.project.customername;
      this.modalStage.organizationname = this.project.organizationname;
      this.modalStage.organizationId = this.project.organizationId;
      this.modalStage.orgdesc = this.project.orgdesc;
      this.modalStage.orgemail = this.project.orgemail;
      this.modalStage.orglogourl = this.project.orglogourl;
      this.modalStage.orgwww = this.project.orgwww;
      this.modalStage.creator = SessionHelper.getUserSub();

      this.modalStage.projectId = SessionHelper.getCurrentProject();
      this.modalStage.projectname = JSON.parse(
        SessionHelper.getCurrentProjectFull()
      ).title;
      //console.log(this.modalStage);
      this.ppsrv
        .addStage(this.modalStage)
        .pipe(untilDestroyed(this))
        .subscribe((result) => {
          // Add stage to UI
          this.modalStage.stageId = result;
          this.allStageList.push(this.modalStage);
          this.modalStage = new Stage();
          this.modalservice.close("stagemodal");
          this.getScreenSize();
          this.showAlert(true);
        });
    }
  }

  deleteStage(stage: Stage) {
    //Remove from UI. Deletion from BE happens in stage componenet
    this.allStageList.splice(this.stageList.indexOf(stage), 1);
    this.getScreenSize();
  }
  resetModal() {
    this.modalStage = new Stage();
    this.errorMessage = undefined;
  }

  validate() {
    if (
      this.modalStage.enddate &&
      this.modalStage.startdate &&
      this.modalStage.title &&
      this.modalStage.description
    ) {
      this.formIsValid = true;
    } else {
      this.formIsValid = false;
    }
  }

  setNewStage() {
    //console.log(this.project);
    this.modalStage.enddate = this.project.end_date.toString();
    this.modalStage.startdate = this.project.start_date.toString();
    this.modalStage.stagevisibility = "shared";
  }
  filterToggle() {
    this.filtertoggle = !this.filtertoggle;
    if (!this.filtertoggle) {
      this.filterTaskList("");
    }
  }

  showAlert(boolean) {
    this.showalerttoggle = boolean;
    if (this.showalerttoggle == true) {
      setTimeout(() => {
        this.showalerttoggle = false
      }, 1500);
    }
  }
}
